export default function FormTab({
  label,
  isActive,
  handleOnClick,
}: {
  label: string;
  isActive: boolean;
  handleOnClick: () => void;
}) {
  return (
    <button
      type="button"
      className={` pb-2 font-satoshi text-xl font-semibold text-white 2xl:text-2xl  ${
        isActive ? "border-b-2  border-secondary opacity-100 " : " opacity-50"
      }`}
      onClick={handleOnClick}
    >
      {label}
    </button>
  );
}
